module.exports = __webpack_public_path__ + "static/media/intel_logo.13dcea8f.svg";